/*
 * File: GetCourseCompletionCriteria.ts
 * Author: Austin Robinson
 * Date Created: 10/9/2023
 * Copyright (c) DrivingDoc 2023
 */
import { createQuery } from 'react-query-kit';

import { PostGreSQLInterval, privateApi } from 'api';

export type GetCourseCompletionCriteriaParams = {
  courseId: string;
};

export type GetCourseCompletionCriteriaResult = {
  tenant_id: string;
  course_id: string;
  updated_at: string;
  performance_time_required: PostGreSQLInterval | null;
  observation_time_required: PostGreSQLInterval | null;
  updated_by_user: {
    tenant_id: string;
    id: string;
    title: string | null;
    first_name: string | null;
    middle_name: string | null;
    last_name: string | null;
    nickname: string | null;
    email: string | null;
    date_of_birth: string | null;
    sex: string | null;
    active: boolean;
    created_at: string | null;
    updated_at: string | null;
    created_by: string | null;
    updated_by: string | null;
    des_id: string | null;
  };
};

async function getCourseCompletionCriteria(
  params: GetCourseCompletionCriteriaParams,
): Promise<GetCourseCompletionCriteriaResult> {
  // make api call
  const result = await privateApi.get(
    `${import.meta.env.VITE_API_BASE_URL}/courses/${params.courseId}/completionCriteria`,
    {},
  );

  // return the data object
  return result.data as GetCourseCompletionCriteriaResult;
}

const useGetCourseCompletionCriteria = createQuery<
  GetCourseCompletionCriteriaResult,
  GetCourseCompletionCriteriaParams,
  Error
>({
  queryKey: ['course_completion_criteria'],
  fetcher: (variables) => getCourseCompletionCriteria(variables),
});

export { getCourseCompletionCriteria, useGetCourseCompletionCriteria };
